export enum Endpoints {
  SAVE_SHIPPING_INFO = '/api/v1/public/guest/shipping/cart-ship',
  CREATE_SHIPPING_INFO = '/api/v1/public/guest/add/cart-add',
  GET_BUNDLES = '/api/v1/public/guest/bundle/accessories',
  GET_PAYURL = '/api/v1/public/guest/cart/payurl',
  CREATE_GUEST_USER = '/api/v1/public/guest/user-create',
  GET_ACCESSORIES = '/api/v1/public/guest/accessories',
  GET_GUEST_CART = '/api/v1/public/guest/get/cart-get',
  GET_GUEST_PRODUCT_BRANDS = '/api/v1/public/guest/brands/products',
  GET_GUEST_PRODUCTS = '/api/v1/public/guest/product',
  REMOVE_USER_CART = '/api/v1/public/guest/remove/cart-remove',
}
